import { render } from "./CallPlayer.vue?vue&type=template&id=6f666228&ts=true"
import script from "./CallPlayer.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallPlayer.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/call/components/CallPlayer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f666228"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f666228', __exports__)) {
    api.reload('6f666228', __exports__)
  }
  
  module.hot.accept("./CallPlayer.vue?vue&type=template&id=6f666228&ts=true", () => {
    api.rerender('6f666228', render)
  })

}


export default __exports__